import { render } from "./app-form-invoice-product-item.vue?vue&type=template&id=ada730a4&scoped=true"
import script from "./app-form-invoice-product-item.vue?vue&type=script&lang=js"
export * from "./app-form-invoice-product-item.vue?vue&type=script&lang=js"

import "./app-form-invoice-product-item.vue?vue&type=style&index=0&id=ada730a4&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ada730a4"],['__file',"src/views/components/form/reference/app-form-invoice-product-item.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ada730a4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ada730a4', __exports__)) {
    console.log('reload')
    api.reload('ada730a4', __exports__)
  }
  
  module.hot.accept("./app-form-invoice-product-item.vue?vue&type=template&id=ada730a4&scoped=true", () => {
    console.log('re-render')
    api.rerender('ada730a4', render)
  })

}


export default __exports__